export default __webpack_public_path__ + "static/rencipe-recipe-detail-focused-bc6d2858fcd633d139ae74184da8d14c.png";